module.exports = __webpack_public_path__ + "static/media/BOULIA SHIRE.2dc584e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_areas/BOULIA SHIRE.svg
// module id = 524
// module chunks = 0